<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title
        >Are you sure you want to remove
        <b v-if="model.key == 'ClassroomOnEvent'" class="mx-1 error--text">{{ item.Classroom.name }}</b
        >
          <b v-else-if="model.key == 'EventOnClassroom'" class="mx-1 error--text">{{ item.Event.name }}</b
        >
        ?</v-card-title
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray darken-1" text @click="close">{{$t("action.cancel")}}</v-btn>
        <v-btn
          color="error darken-1"
          text
          @click="confirm"
          :loading="api.isLoading"
          >{{$t("action.ok")}}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>


//EOC
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: mapState({
    //
  }),
  props: ["model"],
  data: () => ({
    key: false,
  
    //EOC
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC

    form: {},
    dialog: false,
    url: null,
  }),
  created() {
    //BOC:[url]
    if (this.model.key == "ClassroomOnEvent") {
      this.url = `${this.$api.servers.backend}/v1/event/${this.$route.params.id}/classroom/delete`;
    }else if(this.model.key == "EventOnClassroom"){
       this.url = `${this.$api.servers.backend}/v1/classroom/${this.$route.params.id}/event/delete`;
    }else if(this.model.key == "FestivalSchool"){
       this.url = `${this.$api.servers.moderator}/v1/festival/${this.$route.params.id}/school/delete`;
    }else if(this.model.key == "EventOnFestival"){
       this.url = `${this.$api.servers.moderator}/v1/festival/${this.$route.params.id}/event/delete`;
    }

    //EOC
    //BOC:[api]
    this.api.url = this.url;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = () => {
      this.api.isLoading = false;
      this.dialog = false;
      this.$emit("refetch");
    };
    //EOC
  },
  mounted() {
    //
  },
  methods: {
    open(item) {
      this.item = item;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      if (this.model.key == "ClassroomOnEvent") {
      this.api.params = this.$_.clone({ classroomId: this.item.classroomId });
    }else if(this.model.key == "EventOnClassroom"){
       this.api.params = this.$_.clone({ eventId: this.item.eventId });
    }else if(this.model.key == "FestivalSchool"){
       this.api.params = this.$_.clone({ schoolId: this.item.schoolId });
    }else if(this.model.key == "EventOnFestival"){
       this.api.params = this.$_.clone({ eventId: this.item.id });
    }
      this.$api.fetch(this.api);
    },
  },
};
</script>